import {Helpcenter} from './Helpcenter/Helpcenter'
import {OrderRequest} from './OrderRequest/OrderRequest'
import { RefundForm } from "./RefundForm/RefundForm"
import { CustomHtml } from "./CustomHtml/CustomHtml"
import { ProductPreviewSlider } from "./ProductPreviewSlider/ProductPreviewSlider"
import { NewsletterSignup } from "./NewsletterSignup/NewsletterSignup"
import { FeaturedProducts } from "./FeaturedProducts/FeaturedProducts"
import { ContactForm } from "./ContactForm/ContactForm"
import { HeroBlockImage } from "./HeroBlockImage/HeroBlockImage"
import { ProductGrid } from "./ProductGrid/ProductGrid"
import { HtmlWidget } from "./HtmlWidget/HtmlWidget"
import { RetailerLogos } from "./RetailerLogos/RetailerLogos"
import { ImageSection } from "./ImageSection/ImageSection"
import { HeroTextCta } from "./HeroTextCta/HeroTextCta"
import { PressLogos } from "./PressLogos/PressLogos"
import { AccordionProductInfo } from "./AccordionProductInfo/AccordionProductInfo"
import { TextContent } from "./TextContent/TextContent"
import { ReviewsLandingpage } from "./ReviewsLandingpage/ReviewsLandingpage"
import { OfferLandingpage } from "./OfferLandingpage/OfferLandingpage"
import { VideoTextCta } from "./VideoTextCta/VideoTextCta"
import { TextAnimatedGif } from "./TextAnimatedGif/TextAnimatedGif"
import { ImageBenefitsCta } from "./ImageBenefitsCta/ImageBenefitsCta"
import { PromisesWithImage } from "./PromisesWithImage/PromisesWithImage"
import { CtaHeader } from "./CtaHeader/CtaHeader"
import { Iframe } from "./Iframe/Iframe"
import { SubscriptionConfirmation } from "./SubscriptionConfirmation/SubscriptionConfirmation"
import { SectionProduct } from "./SectionProduct/SectionProduct"
import { StoreFinder } from "./StoreFinder/StoreFinder"
import { CtaSection } from "./CtaSection/CtaSection"
import { IngredientSlider } from "./IngredientSlider/IngredientSlider"
import { Faq } from "./Faq/Faq"
import { SliderReviews } from "./SliderReviews/SliderReviews"
import { NutritionInfo } from "./NutritionInfo/NutritionInfo"
import { Anwendung } from "./Anwendung/Anwendung"
import { PressSlider } from "./PressSlider/PressSlider"
import { MainMenu } from "./MainMenu/MainMenu"
import { InstaGrid } from "./InstaGrid/InstaGrid"
import { Promises } from "./Promises/Promises"
import { AccentColorImageText } from "./AccentColorImageText/AccentColorImageText"
import { BlockTextWithImage } from "./BlockTextWithImage/BlockTextWithImage"
import { BlockTextPlain } from "./BlockTextPlain/BlockTextPlain"
import { Contact } from "./Contact/Contact"
import { LegalFooter } from "./LegalFooter/LegalFooter"
import { HeroTextOnBackground } from "./HeroTextOnBackground/HeroTextOnBackground"
import { ListBenefits } from "./ListBenefits/ListBenefits"
import { PreHeader } from "./PreHeader/PreHeader"
import { Footer } from "./Footer/Footer"
import { HeroAboveTheFold } from "./HeroAboveTheFold/HeroAboveTheFold"

export const allSectionComponents = {
  Helpcenter,
  OrderRequest,
  RefundForm,
  CustomHtml,
  ProductPreviewSlider,
  NewsletterSignup,
  FeaturedProducts,
  ContactForm,
  HeroBlockImage,
  ProductGrid,
  HtmlWidget,
  RetailerLogos,
  ImageSection,
  HeroTextCta,
  PressLogos,
  AccordionProductInfo,
  TextContent,
  ReviewsLandingpage,
  OfferLandingpage,
  VideoTextCta,
  TextAnimatedGif,
  ImageBenefitsCta,
  PromisesWithImage,
  CtaHeader,
  Iframe,
  SubscriptionConfirmation,
  SectionProduct,
  StoreFinder,
  CtaSection,
  IngredientSlider,
  Faq,
  SliderReviews,
  NutritionInfo,
  Anwendung,
  PressSlider,
  MainMenu,
  InstaGrid,
  Promises,
  AccentColorImageText,
  BlockTextWithImage,
  BlockTextPlain,
  Contact,
  LegalFooter,
  HeroTextOnBackground,
  ListBenefits,
  HeroAboveTheFold,
  PreHeader,
  Footer,
}
